jQuery(document).ready(function($) {

    const $titleText = $('.aheto-contents__form-title').html();

    function handleEvents() {
        const $day = $('.tribe-events-calendar-month__day');
        const $eventDetailsContainer = $('.aheto-contents__event-details--container');

        const homeUrl = $eventDetailsContainer.attr('data-home');

        $day.each(function () {
            if ($(this).hasClass('tribe-events-calendar-month__day--current')) {
                getData(this);
            }
        });

        $day.live('click', function () {
            getData(this);
        });


        function getData(targetElem) {
            const events = $(targetElem).find('.tribe-events-calendar-month__calendar-event');
            const multiDayEvents = $(targetElem).find('.tribe-events-calendar-month__events').find('.tribe-events-calendar-month__multiday-event');

            const emptyMessage = $('.aheto-contents__event-details').attr('data-empty');
            const ctaMessage = $('.aheto-contents__event-details').attr('data-cta');
            const ids = [];


            $eventDetailsContainer.html('');

            if (events.length) {
                events.each(function () {
                    const id = $(this).attr('id')
                    ids.push(id);
                });
            }

            if (multiDayEvents.length) {
                multiDayEvents.each(function () {
                    const id = $(this).attr('data-event-id')
                    ids.push(id);
                });
            }




            if (ids.length) {
                ids.forEach(function (elem) {
                    $.ajax({
                        url: `${homeUrl}/wp-json/tribe/events/v1/events/${elem}`,
                        beforeSend: function() {
                            $eventDetailsContainer.parent().find('.loading').slideDown();
                            $day.each(function () {
                                $(this).css('pointer-events', 'none');
                            })
                        },

                        success: function(data){
                            $eventDetailsContainer.parent().find('.loading').slideUp();
                            
                            console.log(data, data.website);
                            
                            $day.each(function () {
                                $(this).css('pointer-events', '');
                            });

                            $eventDetailsContainer.append(`
                            <div class="aheto-contents__event-item">
                                <div class="aheto-contents__event-item--date">
                                    
                                    ${ data.start_date_details.day === data.end_date_details.day 
                                        ?
                                            moment(data.start_date).format("MMMM Do") 
                                        : 
                                            moment(data.start_date).format("MMMM Do") + ' - ' + moment(data.end_date).format("MMMM Do")
                                    }
                                  
                            
                                </div>
                               ${
                                data.website ?
                                    `
                                            <a target="_blank" href=${data.website}>
                                                <h5 class="aheto-contents__event-item--title">${data.title}</h5>
                                            </a>
                                        ` : `<h5 class="aheto-contents__event-item--title">${data.title}</h5>`

                                }
                                
                                ${
                                data.venue.address
                                    ?
                                    `<div class="aheto-contents__event-item--venue">
                                            ${data.venue.address}
                                            </div>`
                                    : ''
                                }
                                
                                
                                
                                <div class="aheto-contents__event-item--description">
                                    ${data.description}
                                </div>
                                
                                <button class="aheto-contents__event-item--button">
                                    ${ctaMessage}
                                </button>
                            </div>
                        `);
                            handleForm('.aheto-contents__event-details');
                        }
                    });
                });
            } else {
                $eventDetailsContainer.append(`<h4 class="empty">${emptyMessage}</h4>`);
            }
        }
    }

    function handleForm(selector) {
        const $meetBtn = $(selector).find('button');
        const $form = $('.aheto-contents__form');

        const $closeForm = $form.find('.aheto-contents__form-close');

        if ($meetBtn.length) {
            $meetBtn.live('click', function () {

                $form.find('.wpcf7-form').trigger('reset');
                $('.aheto-contents__form-title').html($titleText);

                const eventTitle = $(this).parent('.aheto-contents__event-item').find('h5').text();

                $form.find('.event-title').val(eventTitle);

                $form.find('.row').slideDown('slow');
                $form.find('.wpcf7-response-output').slideUp('slow');

                $('.aheto-contents__form-title').slideDown('slow');
                $('.aheto-contents__form-subtitle').slideDown('slow');

                $form.slideDown('slow');

                $('html,body').animate({
                    scrollTop: $form.offset().top - 150
                }, 1000);
            });



            $closeForm.on('click', function () {
                $form.slideUp('slow');
            })
        }
    }

    handleUpcomingEvents('.list-info');

    function handleUpcomingEvents(selector) {
        const $meetBtn = $(selector).find('button');
        const $form = $('.aheto-contents__form');

        const $closeForm = $form.find('.aheto-contents__form-close');

        if ($meetBtn.length) {
            $meetBtn.on('click', function () {

                const $response = $form.find('.wpcf7-response-output');
                $response.empty();

                $form.find('.wpcf7-form').trigger('reset');
                $('.aheto-contents__form-title').html($titleText);

                $form.find('.event-title').val($(this).attr('data-event'));


                $form.find('.row').slideDown('slow');
                $form.find('.wpcf7-response-output').slideUp('slow');

                $('.aheto-contents__form-title').slideDown('slow');
                $('.aheto-contents__form-subtitle').slideDown('slow');


                $form.slideDown('slow');

                $('html,body').animate({
                    scrollTop: $form.offset().top - 150
                }, 1000);
            });

            $closeForm.on('click', function () {
                $form.slideUp('slow');
            })
        }
    }

    function handleFormSubmit() {
        const $submitBtn = $('.wpcf7-submit' );


        $submitBtn.on( 'click', function( e) {
            const $form	= $(this).parents('form');

            console.log($titleText);

            $form.parent().on('wpcf7mailsent', function () {

                $(this).find('.row').slideUp('slow');
                $('.aheto-contents__form-title').html('Success');
                $('.aheto-contents__form-subtitle').slideUp('slow');

            });
        } );
    }

    $(window).on('load', function () {
        handleEvents();
        handleFormSubmit();
    });
});